import { render, staticRenderFns } from "./location-rooms.vue?vue&type=template&id=112f6724&scoped=true&"
import script from "./location-rooms.vue?vue&type=script&lang=js&"
export * from "./location-rooms.vue?vue&type=script&lang=js&"
import style0 from "./location-rooms.vue?vue&type=style&index=0&id=112f6724&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "112f6724",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardSubtitle,VCardTitle})
